export const initialState = {
    is_loading_disputes: true,
    disputes: [],
    disputes_list_search_text: "",
    selected_dispute: null,
    is_get_archive_dispute: false,
    is_show_sales_invoices: false,
    is_show_credit_notes: false,
}